import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useShopifyConnectionStatus = () => {
  return useQuery({
    queryKey: ["shopify-connection-status"],
    queryFn: async () => await apiClient.getShopifyConnectionStatus(),
    staleTime: 5 * 60 * 1000,
  });
};
